var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-form-item',{attrs:{"label":"Niveau de closing"}},[_c('el-select',{attrs:{"value":_vm.value,"clearable":"","placeholder":"1, 2, 3, 4"},on:{"change":_vm.onValueChange}},_vm._l(([1, 2, 3, 4]),function(closingLevel){return _c('el-option',{key:closingLevel,attrs:{"label":closingLevel,"value":closingLevel}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }